import { Nullable } from 'V2/Types';

export const formatPrice = (
  price: Nullable<string | number | boolean>
): string | null => {
  if (!price || typeof price === 'boolean') {
    return null;
  }
  if (typeof price === 'string') {
    return parseFloat(price).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }
  return price.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
};
